export default __webpack_public_path__ + "c164cea5ba75bdc5a17a7ac50a944cc9.png";